import { render, staticRenderFns } from "./TheFacilitiesLockAddForm.vue?vue&type=template&id=390150ff&"
import script from "./TheFacilitiesLockAddForm.vue?vue&type=script&lang=js&"
export * from "./TheFacilitiesLockAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports